// src/boot-loader.tsx
import React from 'react';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';

import App from './App';
import { environment as buildTimeEnv, EnvConfig } from './environment';

// 1) Merge build-time + any runtime overrides
const env: EnvConfig = {
  ...buildTimeEnv,
  ...(window.__ENVIRONMENT__ as Partial<EnvConfig> ?? {})
} as EnvConfig;

// 2) Sanity-check: no leftover #{…}# tokens
// Object.entries(env).forEach(([key, val]) => {
//   if (typeof val === 'string' && val.includes('#{')) {
//     console.error(`Un-replaced token for ${key}:`, val);
//     throw new Error(`Configuration error: ${key} still contains #{…}#`);
//   }
// });

// 3) GTM setup
const gtmParams = { id: env.GTM_KEY };

const BootLoader: React.FC = () => (
  <GTMProvider state={gtmParams}>
    <App />
  </GTMProvider>
);

export default BootLoader;

// we no longer call ReactDOM.render() here—
// that lives in index.tsx so this file can be split out cleanly.
